import { Json } from './types.model';

export class WsError<C = number, T = string> extends Error {
    code: C;
    type: T;
    context?: Json;

    constructor(code: C, type: T, message: string, context?: Json) {
        super(message);
        this.code = code;
        this.type = type;
        this.context = context;
    }
}
